import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";
const ActiveWhiteboards = () => {
    const localizedHref = useLocalizedHref("/software/confluence/whiteboards");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.activeWhiteboards.content.body"
                    defaultMessage="Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. Collaborate, brainstorm, draw and visualize ideas in a freeform way with up to 3 active whiteboards per user. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="learn more"
                                data-track-event="ConfluencePricingPageTeam24.activeWhiteboards.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default ActiveWhiteboards;
